// Shared open/close state for the global navigation drawer. The drawer lives in
// App.vue; keeping the state module-level lets any view toggle it.
import { ref } from 'vue'

const drawer = ref(false)

export function useNavDrawer() {
  return {
    drawer,
    open: () => {
      drawer.value = true
    },
    toggle: () => {
      drawer.value = !drawer.value
    },
  }
}
